import { getController } from '@/controllers/request';

export default {
  namespaced: true,
  state: {
    navigationData: {}
  },
  mutations: {
    setNavigationData(state, data) {
      state.navigationData = data;
    }
  },
  actions: {
    async getNavigationData({ commit }) {
      try {
        const { data } = await getController({
          params: {
            module: 'Home',
            action: 'getHeaderMenuData'
          }
        });
        commit('setNavigationData', data);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
